import { IndexType } from 'types/common';

export const SCREEN_TYPE: IndexType = {
  VERTICAL: '세로형',
  HORIZONTAL: '가로형',
  ETC: '기타',
};
